import { render } from "./PrimeVueImage.vue?vue&type=template&id=9df1053c"
import script from "./PrimeVueImage.vue?vue&type=script&lang=js"
export * from "./PrimeVueImage.vue?vue&type=script&lang=js"

import "./PrimeVueImage.vue?vue&type=style&index=0&id=9df1053c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__